(function() {
    'use strict';
    window.addEventListener('load', function() {
        var forms = document.getElementsByClassName('needs-validation');
        var validation = Array.prototype.filter.call(forms, function(form) {
            form.addEventListener('submit', function(event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();
$('form').on('submit', function(){
    $('.form-control-chosen[required]').each(function(){
        if ( $( this ).val() === '' ) $( this ).next().removeClass('is-valid').addClass('is-invalid');
        else $( this ).next().removeClass('is-invalid').addClass('is-valid');
    });
});
